module.exports = __webpack_public_path__ + "img/pause.fe9969cc.svg";